import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authExchange } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        await authExchange(sessionId);
        await refresh();
        // Strip the fragment
        window.history.replaceState({}, document.title, window.location.pathname);
        toast.success("Angemeldet");
        nav("/dashboard", { replace: true });
      } catch (e) {
        toast.error("Anmeldung fehlgeschlagen");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]" data-testid="auth-callback">
      <div className="eid-card p-6 text-sm text-zinc-400">Anmeldung abschließen…</div>
    </div>
  );
}
